module.exports = __webpack_public_path__ + "static/media/bR.9a79237a.svg";